<div class="board-attachments" [class.is-fetching]="$fetching() && !$loading()" [class.is-grouped]="!$flat()" [class.selection-active]="$selectedIds().size > 0">
  @if ($loading() && !$items().length) {
    <div class="board-attachments-state">
      <i class="fa fa-spinner fa-spin"></i>
      <span>Loading…</span>
    </div>
  } @else if (!$items().length) {
    <empty-message message="No files were found." icon="fa-regular fa-files" />
  } @else if ($flat()) {
    <div class="board-attachments-grid">
      @for (item of $items(); track item._id) {
        <ng-container *ngTemplateOutlet="tile; context: { $implicit: item }" />
      }
    </div>
  } @else {
    <accordion [multi]="true">
      @for (group of $groups(); track group.key) {
        <accordion-group [title]="group.title" [showTitleLine]="true" [collapsed]="false">
          <div class="board-attachments-grid">
            @for (item of group.items; track item._id) {
              <ng-container *ngTemplateOutlet="tile; context: { $implicit: item }" />
            }
          </div>
        </accordion-group>
      }
    </accordion>
  }
</div>

<ng-template #tile let-item>
  <attachment
    [attachment]="item"
    [selected]="isSelected(item)"
    [selectable]="$selectable()"
    [selectOnClick]="$selectable()"
    selectionIndicator="checkbox"
    [showMetadata]="true"
    [showTags]="!!item.tags?.length"
    [deletable]="false"
    [expandable]="false"
    (selectionChanged)="onSelectionChanged($event)"
  />
</ng-template>
